/**
 * Public footer with product navigation, trust cues, and legal access.
 * @param {{
 *   onOpenTerms?: () => void,
 *   onOpenProduct?: () => void,
 *   onOpenHow?: () => void,
 *   onOpenSecurity?: () => void,
 *   onOpenPricing?: () => void,
 *   onOpenFaq?: () => void,
 *   onGetStarted?: () => void,
 * }} props
 */
export function SiteFooter({
  copy,
  onOpenTerms,
  onOpenProduct,
  onOpenHow,
  onOpenSecurity,
  onOpenPricing,
  onOpenFaq,
  onGetStarted,
}) {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <strong className="site-footer-logo">AfterMe.ca</strong>
          <p className="site-footer-tagline">{copy.tagline}</p>
          {typeof onGetStarted === "function" ? (
            <button type="button" className="site-footer-cta" onClick={onGetStarted}>
              {copy.cta.startPlan}
            </button>
          ) : null}
        </div>

        <div className="site-footer-col">
          <h3 className="site-footer-heading">{copy.productHeading}</h3>
          <div className="site-footer-nav-list">
            {typeof onOpenProduct === "function" ? (
              <button type="button" className="site-footer-text-button" onClick={onOpenProduct}>
                {copy.productOverview}
              </button>
            ) : null}
            {typeof onOpenHow === "function" ? (
              <button type="button" className="site-footer-text-button" onClick={onOpenHow}>
                {copy.how}
              </button>
            ) : null}
            {typeof onOpenSecurity === "function" ? (
              <button type="button" className="site-footer-text-button" onClick={onOpenSecurity}>
                {copy.security}
              </button>
            ) : null}
            {typeof onOpenPricing === "function" ? (
              <button type="button" className="site-footer-text-button" onClick={onOpenPricing}>
                {copy.pricing}
              </button>
            ) : null}
            {typeof onOpenFaq === "function" ? (
              <button type="button" className="site-footer-text-button" onClick={onOpenFaq}>
                {copy.faq}
              </button>
            ) : null}
          </div>
        </div>

        <div className="site-footer-col">
          <h3 className="site-footer-heading">{copy.trustHeading}</h3>
          <ul className="site-footer-list">
            <li className="site-footer-trust-item">
              <span className="site-footer-trust-icon" aria-hidden="true">
                🔒
              </span>
              <span className="site-footer-muted">{copy.trust.encrypted}</span>
            </li>
            <li className="site-footer-trust-item">
              <span className="site-footer-trust-icon" aria-hidden="true">
                🛡️
              </span>
              <span className="site-footer-muted">{copy.trust.control}</span>
            </li>
            <li className="site-footer-trust-item">
              <span className="site-footer-trust-icon" aria-hidden="true">
                ⏳
              </span>
              <span className="site-footer-muted">{copy.trust.noAutoShare}</span>
            </li>
            <li className="site-footer-muted site-footer-third-party">{copy.trust.thirdParty}</li>
          </ul>
        </div>

        <div className="site-footer-col">
          <h3 className="site-footer-heading">{copy.legalHeading}</h3>
          <ul className="site-footer-list">
            <li>
              <a href="mailto:support@afterme.ca" className="site-footer-link">
                support@afterme.ca
              </a>
            </li>
            <li className="site-footer-muted">{copy.responseTime}</li>
            {typeof onOpenTerms === "function" ? (
              <li>
                <button type="button" className="site-footer-text-button" onClick={onOpenTerms}>
                  {copy.terms}
                </button>
              </li>
            ) : null}
            <li className="site-footer-muted site-footer-legal-short">
              {copy.legal.disclaimer}
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer-bar">
        <p className="site-footer-copy">
          © {year} {copy.copyrightSuffix}
        </p>
      </div>
    </footer>
  );
}
